"use client";
import { useEffect, useState } from "react";
import SuitPreview from "../../components/SuitPreview"; // Adjust path as needed
// Replace these with your real keys from Step 1
const CK = "ck_your_consumer_key_here";
const CS = "cs_your_consumer_secret_here";
const WP_URL = "https://alshakilee.com/wp-json/wc/v3/products";

export default function FabricSelection() {
  const [fabrics, setFabrics] = useState([]);
  const [activeColor, setActiveColor] = useState("#1e293b"); // Default Navy Blue
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch only products in the "fabrics" category
    fetch(`${WP_URL}?consumer_key=${CK}&consumer_secret=${CS}&category=fabrics`)
      .then((res) => res.json())
      .then((data) => {
        setFabrics(data);
        setLoading(false);
      })
      .catch((err) => console.error("Error loading fabrics:", err));
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans text-black">
      <div className="flex flex-col lg:flex-row min-h-screen">
        
        {/* LEFT SIDE: THE LIVE PREVIEW (STUCK TO SCREEN) */}
        <div className="lg:w-1/2 bg-slate-100 lg:sticky lg:top-0 h-[50vh] lg:h-screen flex flex-col items-center justify-center p-10">
          <h2 className="mb-8 text-sm font-bold tracking-[0.2em] uppercase text-slate-400">Real-time Visualization</h2>
          <SuitPreview color={activeColor} />
          <div className="mt-8 text-center">
             <p className="text-slate-500 text-sm italic">Move your mouse over a fabric to see it on the suit</p>
          </div>
        </div>

        {/* RIGHT SIDE: THE FABRIC LIST */}
        <div className="lg:w-1/2 p-8 md:p-16 overflow-y-auto">
          <header className="mb-12">
            <h1 className="text-5xl font-black uppercase mb-4 tracking-tighter">Choose Fabric</h1>
            <div className="h-2 w-20 bg-black"></div>
          </header>

          <div className="space-y-6">
            {fabrics.map((fabric: any) => (
              <div 
                key={fabric.id} 
                onMouseEnter={() => {
                    // We check if you have a "Color" meta-field in WooCommerce
                    // If not, we'll just use a random color for now to show the effect
                    const colors = ["#2c3e50", "#7f8c8d", "#1a1a1a", "#4a4a4a"];
                    setActiveColor(colors[Math.floor(Math.random() * colors.length)]);
                }}
                className="flex items-center gap-6 p-6 border border-slate-100 rounded-xl hover:border-black transition-all cursor-pointer group"
              >
                <img src={fabric.images[0]?.src} className="w-24 h-24 object-cover rounded-lg" />
                <div className="flex-1">
                  <h3 className="text-xl font-bold uppercase">{fabric.name}</h3>
                  <p className="text-slate-500 font-semibold uppercase text-xs tracking-widest mt-1">OMR {fabric.price}</p>
                </div>
                <button className="opacity-0 group-hover:opacity-100 bg-black text-white px-6 py-2 rounded-full text-xs transition-all">
                  Select
                </button>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}